// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../css-loader-virtual-8b8790ede6/0/cache/css-loader-npm-7.1.2-7540f12884-ddde22fb10.zip/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../css-loader-virtual-8b8790ede6/0/cache/css-loader-npm-7.1.2-7540f12884-ddde22fb10.zip/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tooltip-container {
  --tooltipBackground: #fff;
  --tooltipBorder: #c0c0c0;
  --tooltipColor: #000;

  background-color: var(--tooltipBackground);
  border-radius: 3px;
  border: 1px solid var(--tooltipBorder);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.18);
  color: var(--tooltipColor);
  display: flex;
  flex-direction: column;
  padding: 0.4rem;
  transition: opacity 0.3s;
  z-index: 9999;
}

.tooltip-container[data-popper-interactive='false'] {
  pointer-events: none;
}

.tooltip-arrow {
  height: 1rem;
  position: absolute;
  width: 1rem;
  pointer-events: none;
}

.tooltip-arrow::before {
  border-style: solid;
  content: '';
  display: block;
  height: 0;
  margin: auto;
  width: 0;
}

.tooltip-arrow::after {
  border-style: solid;
  content: '';
  display: block;
  height: 0;
  margin: auto;
  position: absolute;
  width: 0;
}

.tooltip-container[data-popper-placement*='bottom'] .tooltip-arrow {
  left: 0;
  margin-top: -0.4rem;
  top: 0;
}

.tooltip-container[data-popper-placement*='bottom'] .tooltip-arrow::before {
  border-color: transparent transparent var(--tooltipBorder) transparent;
  border-width: 0 0.5rem 0.4rem 0.5rem;
  position: absolute;
  top: -1px;
}

.tooltip-container[data-popper-placement*='bottom'] .tooltip-arrow::after {
  border-color: transparent transparent var(--tooltipBackground) transparent;
  border-width: 0 0.5rem 0.4rem 0.5rem;
}

.tooltip-container[data-popper-placement*='top'] .tooltip-arrow {
  bottom: 0;
  left: 0;
  margin-bottom: -1rem;
}

.tooltip-container[data-popper-placement*='top'] .tooltip-arrow::before {
  border-color: var(--tooltipBorder) transparent transparent transparent;
  border-width: 0.4rem 0.5rem 0 0.5rem;
  position: absolute;
  top: 1px;
}

.tooltip-container[data-popper-placement*='top'] .tooltip-arrow::after {
  border-color: var(--tooltipBackground) transparent transparent transparent;
  border-width: 0.4rem 0.5rem 0 0.5rem;
}

.tooltip-container[data-popper-placement*='right'] .tooltip-arrow {
  left: 0;
  margin-left: -0.7rem;
}

.tooltip-container[data-popper-placement*='right'] .tooltip-arrow::before {
  border-color: transparent var(--tooltipBorder) transparent transparent;
  border-width: 0.5rem 0.4rem 0.5rem 0;
}

.tooltip-container[data-popper-placement*='right'] .tooltip-arrow::after {
  border-color: transparent var(--tooltipBackground) transparent transparent;
  border-width: 0.5rem 0.4rem 0.5rem 0;
  left: 6px;
  top: 0;
}

.tooltip-container[data-popper-placement*='left'] .tooltip-arrow {
  margin-right: -0.7rem;
  right: 0;
}

.tooltip-container[data-popper-placement*='left'] .tooltip-arrow::before {
  border-color: transparent transparent transparent var(--tooltipBorder);
  border-width: 0.5rem 0 0.5rem 0.4em;
}

.tooltip-container[data-popper-placement*='left'] .tooltip-arrow::after {
  border-color: transparent transparent transparent var(--tooltipBackground);
  border-width: 0.5rem 0 0.5rem 0.4em;
  left: 3px;
  top: 0;
}
`, "",{"version":3,"sources":["webpack://./.yarn/__virtual__/react-popper-tooltip-virtual-76b6e8093a/0/cache/react-popper-tooltip-npm-4.4.2-54ed1200c6-87192cd6a4.zip/node_modules/react-popper-tooltip/dist/styles.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,oBAAoB;;EAEpB,0CAA0C;EAC1C,kBAAkB;EAClB,sCAAsC;EACtC,yCAAyC;EACzC,0BAA0B;EAC1B,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,wBAAwB;EACxB,aAAa;AACf;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,SAAS;EACT,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,SAAS;EACT,YAAY;EACZ,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,OAAO;EACP,mBAAmB;EACnB,MAAM;AACR;;AAEA;EACE,sEAAsE;EACtE,oCAAoC;EACpC,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,0EAA0E;EAC1E,oCAAoC;AACtC;;AAEA;EACE,SAAS;EACT,OAAO;EACP,oBAAoB;AACtB;;AAEA;EACE,sEAAsE;EACtE,oCAAoC;EACpC,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,0EAA0E;EAC1E,oCAAoC;AACtC;;AAEA;EACE,OAAO;EACP,oBAAoB;AACtB;;AAEA;EACE,sEAAsE;EACtE,oCAAoC;AACtC;;AAEA;EACE,0EAA0E;EAC1E,oCAAoC;EACpC,SAAS;EACT,MAAM;AACR;;AAEA;EACE,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,sEAAsE;EACtE,mCAAmC;AACrC;;AAEA;EACE,0EAA0E;EAC1E,mCAAmC;EACnC,SAAS;EACT,MAAM;AACR","sourcesContent":[".tooltip-container {\n  --tooltipBackground: #fff;\n  --tooltipBorder: #c0c0c0;\n  --tooltipColor: #000;\n\n  background-color: var(--tooltipBackground);\n  border-radius: 3px;\n  border: 1px solid var(--tooltipBorder);\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.18);\n  color: var(--tooltipColor);\n  display: flex;\n  flex-direction: column;\n  padding: 0.4rem;\n  transition: opacity 0.3s;\n  z-index: 9999;\n}\n\n.tooltip-container[data-popper-interactive='false'] {\n  pointer-events: none;\n}\n\n.tooltip-arrow {\n  height: 1rem;\n  position: absolute;\n  width: 1rem;\n  pointer-events: none;\n}\n\n.tooltip-arrow::before {\n  border-style: solid;\n  content: '';\n  display: block;\n  height: 0;\n  margin: auto;\n  width: 0;\n}\n\n.tooltip-arrow::after {\n  border-style: solid;\n  content: '';\n  display: block;\n  height: 0;\n  margin: auto;\n  position: absolute;\n  width: 0;\n}\n\n.tooltip-container[data-popper-placement*='bottom'] .tooltip-arrow {\n  left: 0;\n  margin-top: -0.4rem;\n  top: 0;\n}\n\n.tooltip-container[data-popper-placement*='bottom'] .tooltip-arrow::before {\n  border-color: transparent transparent var(--tooltipBorder) transparent;\n  border-width: 0 0.5rem 0.4rem 0.5rem;\n  position: absolute;\n  top: -1px;\n}\n\n.tooltip-container[data-popper-placement*='bottom'] .tooltip-arrow::after {\n  border-color: transparent transparent var(--tooltipBackground) transparent;\n  border-width: 0 0.5rem 0.4rem 0.5rem;\n}\n\n.tooltip-container[data-popper-placement*='top'] .tooltip-arrow {\n  bottom: 0;\n  left: 0;\n  margin-bottom: -1rem;\n}\n\n.tooltip-container[data-popper-placement*='top'] .tooltip-arrow::before {\n  border-color: var(--tooltipBorder) transparent transparent transparent;\n  border-width: 0.4rem 0.5rem 0 0.5rem;\n  position: absolute;\n  top: 1px;\n}\n\n.tooltip-container[data-popper-placement*='top'] .tooltip-arrow::after {\n  border-color: var(--tooltipBackground) transparent transparent transparent;\n  border-width: 0.4rem 0.5rem 0 0.5rem;\n}\n\n.tooltip-container[data-popper-placement*='right'] .tooltip-arrow {\n  left: 0;\n  margin-left: -0.7rem;\n}\n\n.tooltip-container[data-popper-placement*='right'] .tooltip-arrow::before {\n  border-color: transparent var(--tooltipBorder) transparent transparent;\n  border-width: 0.5rem 0.4rem 0.5rem 0;\n}\n\n.tooltip-container[data-popper-placement*='right'] .tooltip-arrow::after {\n  border-color: transparent var(--tooltipBackground) transparent transparent;\n  border-width: 0.5rem 0.4rem 0.5rem 0;\n  left: 6px;\n  top: 0;\n}\n\n.tooltip-container[data-popper-placement*='left'] .tooltip-arrow {\n  margin-right: -0.7rem;\n  right: 0;\n}\n\n.tooltip-container[data-popper-placement*='left'] .tooltip-arrow::before {\n  border-color: transparent transparent transparent var(--tooltipBorder);\n  border-width: 0.5rem 0 0.5rem 0.4em;\n}\n\n.tooltip-container[data-popper-placement*='left'] .tooltip-arrow::after {\n  border-color: transparent transparent transparent var(--tooltipBackground);\n  border-width: 0.5rem 0 0.5rem 0.4em;\n  left: 3px;\n  top: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
